module.exports = __webpack_public_path__ + "img/Brown tang.ee61da76.png";